export enum DeleteTextSnippetsDialogActions {
    DELETE = 'delete',
    CANCEL = 'cancel',
}
